import { Component, OnInit,Output,EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import {OrderByPipe} from 'ngx-pipes';
import{LoopBackAuth, validacionService, pensumService, calificacionService, ActividadService} from '../services/api-rest.service';
import{MessageService} from '../services/message.service';
import { ToastrService } from 'ngx-toastr';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ModalCausasCalificacionComponent} from '../modal/modal-causas-calificacion/modal-causas-calificacion.component';
import {ModalCopiarNotaComponent} from '../modal/modal-copiar-nota/modal-copiar-nota.component'

@Component({
  selector: 'tabla-ingreso-tareas',
  templateUrl: './tabla-ingreso-tareas.component.html',
  styles: [],
  providers:[OrderByPipe,LoopBackAuth, validacionService,pensumService, calificacionService, ActividadService, MessageService, ]

})
export class TablaIngresoTareasComponent implements OnInit, OnChanges {
  @Input() pensum: any
  @Input() asignaturaTipo: any = 1 // 1 calificaciones, 2 observaciones, 3 Asistencia
  @Input() esDueno: any
  @Input() modificarNotas: any
  @Input() spinner: any
  @Input() ruta: any
  @Input() idNivelCurso:number
  @Output() emittTarea= new EventEmitter()
  @Output() emittCurso= new EventEmitter()
  @Output() emittNivelVer= new EventEmitter()
  @Output() emittActualizarNota= new EventEmitter()
  @Output() emittActivarNotas= new EventEmitter()
  @Output() emittReload= new EventEmitter()
  @Output() emittModificarColumn = new EventEmitter()


  alumnos: any
  tareas: any
  padreTareas : any
  search: any
  arbol: any
  nivel: any = 0
  nivelVer: any = 1
  nodo: any
  activarCaudad : any = false
  reload: boolean = true
  updateNota: boolean

  constructor(
    private orderBy: OrderByPipe,
    private ActividadService: ActividadService,
    private calificacionService: calificacionService,
    private pensumService:pensumService,
    public val: validacionService,
    private toastr: ToastrService,
    private modalService: NgbModal,
  ) { }

  ngOnInit() {
    this.activarCaudad = (this.val.accesoSeccion('secretaria') == null)? true: false
  }
  ngOnChanges(changes:SimpleChanges) {
    if(changes.pensum != undefined
      && changes.pensum.currentValue != undefined)
        this.armarArbol(changes.pensum.currentValue)
  }

  armarArbol(idPensum:number){
    this.spinner.isSpinnerVisible = true
    console.log("Pensul-->", idPensum)
    this.ActividadService.tareaAutomatica(idPensum).subscribe(
      item =>{
        if(item != null){

          this.pensumService.estudiantesPensum(idPensum).subscribe(
            alumnos =>{
              console.log("Alumnos --P", alumnos)
              if(isNaN(alumnos)){

                this.ActividadService.arbol(idPensum, this.asignaturaTipo,this.idNivelCurso).subscribe(
                  actividades => {
                    console.log("Actividades --P", actividades);
                    if(isNaN(actividades)){

                      this.emittCurso.emit(actividades[0])
                      this.arbol = this.val.construirArbol(actividades)
                      console.log("arbol pintar -->PPP", this.arbol)
                      console.log("Pensul*****--", idPensum, this.asignaturaTipo)
                      this.calificacionService.calificacionPensum(idPensum, this.asignaturaTipo,this.idNivelCurso).subscribe(
                        calificaciones =>{
                          console.log("Notas --p", calificaciones)

                          if(isNaN(calificaciones)){
                            this.val.construirNotas(this.arbol, alumnos, calificaciones, idPensum)
                            this.alumnos = this.arbol[0].notas
                            let session = JSON.parse(sessionStorage.getItem('nivel'))
                            console.log("tareas -->",this.tareas)
                            if(session == null  || session.nodo == null){
                              this.tareas = this.arbol
                            }else if(session.nodo != null){
                              this.siguienteNivel(session.nivel, session.nodo.id)
                            }

                          }
                          this.spinner.isSpinnerVisible = false
                          this.emittReload.emit()
                        }
                      )
                    }else{
                      this.spinner.isSpinnerVisible = false
                      this.emittReload.emit()
                    }

                  }
                )
              }
            }
          )
        }

      }
    )
  }

  modalCausas(calificacion, tarea, activarNovedad = false){
    let idCalificacion = (calificacion.id != null) ? calificacion.id : 0
    const ventana = this.modalService.open(ModalCausasCalificacionComponent,{
      size:'sm'
    })
    console.log(this.esDueno, (this.ruta =='cursos_asignaturas' || this.ruta == 'docente_asignatura'), this.val.accesoCausas(tarea))
    ventana.componentInstance.idCalificacion = idCalificacion
    ventana.componentInstance.preview = (!activarNovedad) ? ((this.esDueno && (this.ruta =='cursos_asignaturas' || this.ruta == 'docente_asignatura')) ? (this.val.accesoCausas(tarea)) ? false : true: true ): ((this.esDueno && (this.ruta =='cursos_asignaturas' || this.ruta == 'docente_asignatura')) ? this.val.accesoNovedad(tarea) ? false : true: true)
    ventana.componentInstance.activarNovedad = activarNovedad
    ventana.result.then((result)=>{
      //calificacion.observacion = result
      this.armarArbol(this.pensum)
    },(reason)=>{

    })
  }

  validarLineaRefuerzo(tarea, calificacion){
    if(tarea.aca_actividad_tipo_id == 1 ){
      let indexTarea  = this.tareas.findIndex(x=> x.orden == tarea.orden-1)
      let indexCalificacion = this.tareas[indexTarea].notas.findIndex(x=> x.alumno == calificacion.alumno)
      if(this.tareas[indexTarea].notas[indexCalificacion].activar_refuerzo_academico == 1) return true
      return false
    }
    return false
  }


  validarPromediosFinales(tarea: any,calificacion: any){
    console.log("***---",tarea.aca_actividad_tipo_id)
    if(calificacion.estado_alumno == 'R') return false
    if(tarea.aca_actividad_tipo_id == 7 ) return calificacion.rc

    if(tarea.aca_actividad_tipo_id == 8 ){
      if(!this.verificarDerechaTieneNotasPromedioFinal(tarea,calificacion)) return false
      return calificacion.sp
    }

    if(tarea.aca_actividad_tipo_id == 9 ){
      if(!this.verificarDerechaTieneNotasPromedioFinal(tarea,calificacion)) return false
      return calificacion.rm
    }
    if(tarea.aca_actividad_tipo_id == 10 ) return calificacion.eg
    if(calificacion.boquea_final) return false
    return true
  }

  verificarDerechaTieneNotasPromedioFinal(tarea,calificacion){
    let contador = 10 -  parseInt(tarea.aca_actividad_tipo_id)
    console.log("tarea nivel ***", tarea)
    console.log("tareas -->", this.tareas)

    for(let i=1; i <= contador; i++){
      let indexTarea  = this.tareas.findIndex(x=> x.orden == tarea.orden+i)
      console.log("indexTarea-->", indexTarea,tarea.orden,i )
      let indexCalificacion = this.tareas[indexTarea].notas.findIndex(x=> x.alumno == calificacion.alumno)
      if(this.tareas[indexTarea].notas[indexCalificacion].nota > 0) return false
    }
    return true
  }

  validarRefuerzoAcademico(tarea, calificacion){
    if(tarea.aca_actividad_tipo_id == 1 ){
      let indexTarea  = this.tareas.findIndex(x=> x.orden == tarea.orden-1)
      let indexCalificacion = this.tareas[indexTarea].notas.findIndex(x=> x.alumno == calificacion.alumno)
      if(this.tareas[indexTarea].notas[indexCalificacion].activar_refuerzo_academico == 1) return true
      return false
    }
    return true
  }

  siguienteNivel(nivel, idNodo){
      this.nivel = nivel
      this.nivelVer = nivel +1
      this.emittNivelVer.emit(this.nivelVer)
      this.nodo = this.val.buscarNodo(this.arbol,idNodo,0,nivel)
      let sessionNivel = {
        nivel: this.nivel,
        nodo:this.nodo
      }
      sessionStorage.setItem('nivel', JSON.stringify(sessionNivel))
      this.tareas =  this.orderBy.transform(this.nodo.children,'orden')
  }

  atrasNivel(){
    this.nivel = this.nivel-1
    this.nivelVer = this.nivelVer - 1
    this.emittNivelVer.emit(this.nivelVer)
    if(this.nivel != 0){
      this.nodo = this.val.buscarNodo(this.arbol,this.nodo.nodoPapa,0,this.nivel)
      this.tareas =  this.orderBy.transform( this.nodo.children,'orden')
      let sessionNivel = {
        nivel: this.nivel,
        nodo:this.nodo
      }
      sessionStorage.setItem('nivel', JSON.stringify(sessionNivel))
    }else{
      let sessionNivel = {
        nivel: 0,
        nodo:null
      }
      sessionStorage.setItem('nivel', JSON.stringify(sessionNivel))
      this.tareas =  this.orderBy.transform( this.arbol,'orden')
    }
  }

  columnaModificar(idTarea){
    let index  = this.tareas.findIndex(element=> element.id == idTarea)
    if(this.val.accsesoTareas(this.tareas[index])){

        this.tareas[index].modificar = !this.tareas[index].modificar
        this.emittActivarNotas.emit(this.tareas[index].modificar)
        if(!this.tareas[index].modificar) {
          this.emittModificarColumn.emit(true)
          this.spinner.isSpinnerVisible = true
          this.calificacionService.recalcularNotasCurso(this.pensum,0,this.tareas[index].id).subscribe(
            item =>{
              this.armarArbol(this.pensum)
              this.emittModificarColumn.emit(false)
            }
          )
        }
    }else{
      this.toastr.warning("Esta fuera del rango de fechas", "Alerta")
    }

  }

  celdaModificar(tarea, calificacion){
    if(calificacion.nota >= tarea.rango_inicial  && calificacion.nota <= tarea.rango_final ){
      this.updateNota = true
      this.emittActualizarNota.emit(2)
      this.calificacionService.asignarCalificacionEstudianteMateria(this.pensum, calificacion.alumno,calificacion.aca_actividad_id,calificacion.id, calificacion.nota, calificacion.observacion).subscribe(
        item =>{

          if(item != null){
            calificacion.id = item
            this.emittActualizarNota.emit(1)
            this.calcularColumna(tarea)
          }else{
            this.emittActualizarNota.emit(0)
          }
          this.updateNota = false

        }
      )
    }else{
      this.toastr.error("La nota de "+calificacion.descripcion+" no fue ingresa poque no cumple con el rango de "+ tarea.rango_inicial +" a "+ tarea.rango_final,"Error" )
      calificacion.nota = 0
    }

  }

  calcularColumna(tarea){
    let total = 0.00
    for(let item of tarea.notas){
      total  = total + parseFloat(item.nota)
    }
    tarea.total = (total / tarea.notas.length).toFixed(2)
  }

  outputTarea(tarea){
    if(this.val.accsesoTareas(tarea)){
      this.emittTarea.emit(tarea)
    }else{
      this.toastr.warning("Esta fuera del rango de fechas", "Alerta")
    }
  }

  listaTareas(){
    return this.tareas
  }

  deletTarea(idTarea){
    let index  = this.tareas.findIndex(element=> element.id == idTarea)
    this.tareas.splice(index, 1)
  }
  modalCopiarNota(tarea){
    const ventana = this.modalService.open(ModalCopiarNotaComponent,{
      size:'sm',
      backdrop:"static"
    })
    ventana.componentInstance.tarea = tarea
    ventana.componentInstance.pensum = this.pensum
    ventana.result.then((result)=>{
      this.armarArbol(this.pensum)
    },(reason)=>{

    })
  }
  addTarea(item){
    this.armarArbol(this.pensum)
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/element/tabla-ingreso-tareas.component.ts